module.exports = __webpack_public_path__ + "img/bubble_default.d3bb5d49.svg";